import { InjectionToken } from '@angular/core';
import { AbstractAnnotationStore } from './abstract-annotation-store';
import { AnnotationState2D } from './annotation-state-2d';

export const annotationStore2DToken =
  new InjectionToken<AbstractAnnotationStore2D>('annotation store 2d');

export abstract class AbstractAnnotationStore2D<
  T extends AnnotationState2D = AnnotationState2D,
> extends AbstractAnnotationStore<T> {}
